/**
 * CinematicBackdrop — CSS-only animated background.
 * Drop into any page for the "Claude-coded Instagram reels" atmosphere
 * without paying for a WebGL canvas on every route.
 *  - 3 orbiting glowing orbs (coral / magenta / lime)
 *  - radial vignette
 *  - grain overlay
 *  - subtle horizontal scanlines (cinematic CRT vibe)
 */
export default function CinematicBackdrop({ intensity = 'normal' }) {
  // intensity: 'soft' | 'normal' | 'wild'
  const opacity = intensity === 'wild' ? 0.85 : intensity === 'soft' ? 0.35 : 0.6;
  return (
    <div
      aria-hidden
      className="cinematic-backdrop fixed inset-0 pointer-events-none z-0 overflow-hidden"
      style={{ opacity }}
      data-testid="cinematic-backdrop"
    >
      <div className="cb-orb cb-orb--coral" />
      <div className="cb-orb cb-orb--magenta" />
      <div className="cb-orb cb-orb--lime" />
      <div className="cb-vignette" />
      <div className="cb-scanlines" />
    </div>
  );
}
